module.exports = __webpack_public_path__ + "static/media/vegetables1440.ab752df4.jpeg";